export default {
  loggedIn: (state) => {
    return state.active && state.loaded && !!state.user;
  },
};
